import { ASPECT_RATIOS, DesignChannel, getAspectRatioKeyFromDesignChannel } from 'components/NewFileModal/Types'
import { TextChannels } from '../../../../constants'
import { RecentWizard } from 'hooks/useRecentWizards'
import { useMemo } from 'react'
import { TextChannelKey } from 'types'
import { SHOW_RECENT_WIZARDS_MIN } from '../WizardsV3'
import { CREATE_NEW_COMBINED_CHANNELS_MAP } from '../constants'

// we get back design channels instead of aspect ratios, so we need to convert them
export const useFilteredRecentWizards = (recentWizardsQueryChannels: RecentWizard[] | undefined) => {
  return useMemo(() => {
    const recentChannels = (recentWizardsQueryChannels ?? []).map(({ type, channel, width, height }) => {
      if (type === 'Design') {
        return getAspectRatioKeyFromDesignChannel(channel as DesignChannel, width ?? 0, height ?? 0)
      }

      return channel as TextChannelKey
    })
    const filteredRecentChannels = recentChannels.filter((channel) => {
      // in V2 we don't use these anymore so filter them out
      if (['landscape-post', 'portrait-post', 'square-post'].includes(channel)) {
        return false
      }
      return ASPECT_RATIOS.hasOwnProperty(channel) || TextChannels.hasOwnProperty(channel)
    })

    const usingRecentWizards = filteredRecentChannels.length >= SHOW_RECENT_WIZARDS_MIN

    // use the new combined channels for v2
    if (usingRecentWizards) {
      const combinedChannels = filteredRecentChannels.map((channel) => {
        const newChannel = CREATE_NEW_COMBINED_CHANNELS_MAP[channel]
        return newChannel ?? channel
      })

      // remove duplicates from combining
      return [...new Set(combinedChannels)]
    }

    return usingRecentWizards ? filteredRecentChannels : undefined
  }, [recentWizardsQueryChannels])
}
